import React from "react"
import { isEmpty } from "lodash-es"
import { useBackfillReportableFieldContext } from "contexts/BackfillReportableFieldContext"
import FieldLabel from "shared/FieldLabel"
import { FormsyHiddenInput } from "shared/inputs"
import { Select } from "shared/selects"

const questionOptions = (questions) => questions.map((question) => (
  {
    label: question.prompt,
    value: question.uuid,
  }
))

const BackfillReportableFieldFormQuestion = () => {
  const {
    applicableQuestionOptions,
    selectedFormId,
    selectedQuestionUuid,
    selectedReportableFieldId,
    selectQuestion,
  } = useBackfillReportableFieldContext()

  const noQuestions = isEmpty(applicableQuestionOptions)
  const options = questionOptions(applicableQuestionOptions)
  const disabled = !selectedFormId || !selectedReportableFieldId

  return (
    <FieldLabel text="Question">
      <div className="flex flex-col gap-2">
        <Select
          backspaceDelete={false}
          disabled={disabled}
          onChange={selectQuestion}
          options={options}
          value={selectedQuestionUuid}
        />
        <FormsyHiddenInput
          name="questionUuid"
          required
          value={selectedQuestionUuid}
        />
        {
          selectedFormId && selectedReportableFieldId && noQuestions && (
            <p className="text-xs text-dark">
              The selected reportable field may be applied to any question on the selected form.
            </p>
          )
        }
      </div>
    </FieldLabel>
  )
}

export default BackfillReportableFieldFormQuestion
